import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import jobPositionsMenu from "./job-positions.menu";
import jobPositionsRoutes from "./job-positions.routes";
import { FormJobPositionsComponent } from "./pages/form/form-job-positions.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { CoreCardModule } from "../../../@core/components/core-card/core-card.module";
import { ExtendedModule } from "@angular/flex-layout";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { CoreCommonModule } from "../../../@core/common.module";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { JobPositionsListComponent } from "./pages/list/job-positions-list.component";
import { JobCategoriesListComponent } from "./pages/job-categories-list/job-categories-list.component";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { ViewJobPositionsComponent } from "./pages/view/view-job-positions.component";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { CandidatureListComponent } from "./pages/candidature-list/candidature-list.component";
import { UtilsService } from "../../auth/service/utils.service";
import { locale as jobPositionsIt } from "./i18n/jobPositionsIt";
import jobPositionsSettingsLinks from "./job-positions.settings-list";

@NgModule({
  declarations: [FormJobPositionsComponent, JobPositionsListComponent, JobCategoriesListComponent, ViewJobPositionsComponent, CandidatureListComponent],
  imports: [
    CommonModule,
    NgSelectModule,
    AngularEditorModule,
    RouterModule.forChild(jobPositionsRoutes),
    TranslateModule,
    CoreCommonModule,
    ContentHeaderModule,
    CoreCardModule,
    ExtendedModule,
    Ng2FlatpickrModule,
    NgxDatatableModule,
    NgbTooltipModule,
  ],
})
export class JobPositionsModule {
  constructor(private _utilService: UtilsService) {
    this._utilService.initModule("job-position", jobPositionsIt, jobPositionsMenu, jobPositionsSettingsLinks);
  }
}
